import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { MY_CARDS_ROUTES } from 'routes';

export const useMyCards = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTabIndex = MY_CARDS_ROUTES.indexOf(
    location.pathname.split('/')[2] ?? ''
  );
  const currentTab = currentTabIndex === -1 ? 0 : currentTabIndex;
  const [tabIndex, setTabIndex] = useState(currentTab);

  const onTabIndexChange = (index: number) => {
    setTabIndex(index);
    const path = MY_CARDS_ROUTES[index];
    navigate(`/my-cards/${path}`);
  };

  return {
    tabIndex,
    onTabIndexChange,
  };
};
